<template>
  <div class="form-group">
    <label for="search" class="d-none d-lg-inline mr-xl-2 mb-0 pr-2 font-weight-normal">Search</label>
    <div :class="['input-append d-flex flex-grow-1 flex-md-grow-0', options.addAdmin || options.addSecretary || options.addHorse || options.addDraft || options.addEvent || options.addCommittee ? 'mr-md-2 mr-sm-2' : '']">
      <input type="text" id="search" :placeholder="$store.state.showExpand ? 'Search' : ''" class="form-control mb-0 flex-grow-1 flex-md-grow-0" v-model="search">
      <svg class="append" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 14" width="16" height="16"><rect width="100%" height="100%" fill="none"/><g class="currentLayer"><g><path fill="#231815" d="M5.5 11C2.5 11 0 8.5 0 5.5S2.5 0 5.5 0 11 2.5 11 5.5 8.5 11 5.5 11zm0-10C3 1 1 3 1 5.5S3 10 5.5 10 10 8 10 5.5 8 1 5.5 1z"/><path fill="#231815" d="M9.5 8.8l4.4 4.4c.2.2.2.5 0 .7l-.4.1-.4-.1-4.4-4.4.8-.7z"/></g></g></svg>
    </div>
  </div>
</template>

<script>
export default {
  props: ['options'],
  data() {
    return {
      // `options.initialSearch` lets a page open its list pre-filtered (e.g. the Drafts list
      // "find committee secretaries" icon deep-links to Secretary Users with the committee name).
      search: (this.options && this.options.initialSearch) || ''
    }
  },
  created() {
    // Propagate a pre-filled search up to the DataTable so the list starts filtered.
    if (this.search) this.$emit('search', this.search)
  },
  watch: {
    search() {
      this.$emit('search', this.search)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/DataTableFields/Search.vue